<template>
	<v-container id="regular-tables-view" fluid tag="section">
		<material-card icon="mdi-format-list-numbered-rtl" icon-small title="گزارش تراز ماهیانه" color="accent" :loading="loading">
			<v-row>
				<v-col cols="12" style="padding:0 40px 40px">
					<v-row>
						<v-col cols="12" md="4">
							<v-select v-model="month" clearable required single-line return-object :items="months" label="ماه" :error-messages="errorMessages" :rules="[() => !!month || 'ماه را انتخاب کنید']" />
						</v-col>
						<v-col cols="12" md="4" style="text-align:right">
							<v-radio-group v-model="saveType">
								<v-radio :label="'دریافت شده توسط فایل'" :value="1" />
								<v-radio :label="'ثبت شده دستی'" :value="2" />
								<v-radio :label="'هر دو'" :value="3" />
							</v-radio-group>
						</v-col>
						<v-col cols="12" md="4" style="text-align:right">
							<v-btn color="primary" dark class="mx-1" @click="loadData">
								دریافت اطلاعات
							</v-btn>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12" md="6">
							<v-text-field v-model="search" append-icon="mdi-magnify" label="اطلاعات مورد نظر خود جهت جستجو وارد کنید" single-line hide-details class="mb-5" />
						</v-col>
						<v-col cols="12">
							<v-responsive class="overflow-y-auto" max-height="calc(90vh0)">
								<v-data-table :height="dataTableFixedHeight - 100" fixed-header :headers="headers" :items="reportData.items" :items-per-page="50" :search="search" class="elevation-1">
									<template v-slot:item="row">
										<tr>
											<td>
												{{ row.item.fullName }}
											</td>
											<td>
												{{ row.item.personalCode }}
											</td>
											<td>
												{{ row.item.loanTitle }}
											</td>
											<td class="text-center">
												{{ row.item.loanAmount.toString().toPriceFormat() }}
											</td>
											<td class="text-center">
												{{ row.item.payments.toString().toPriceFormat() }}
											</td>
											<td class="text-center">
												{{ row.item.paymentsTotal.toString().toPriceFormat() }}
											</td>
											<td class="text-center">
												{{ row.item.remain.toString().toPriceFormat() }}
											</td>
											<td class="text-center">
												{{ row.item.savedMoney.toString().toPriceFormat() }}
											</td>
											<td class="text-center">
												{{ row.item.savedMoneyTotal.toString().toPriceFormat() }}
											</td>
										</tr>
									</template>
								</v-data-table>
							</v-responsive>
						</v-col>
					</v-row>
					<v-row>
						<v-col cols="12">
							<div class="text-center">
								مجموع پس انداز ها: {{ reportData.totalSavedMonies.toString().toPriceFormat() }}
								<div />
							</div>
						</v-col>
						<v-col cols="12">
							<div class="text-center">
								پرداختی های ماه: {{ reportData.monthPayments.toString().toPriceFormat() }}
								<div />
							</div>
						</v-col>
						<v-col cols="12">
							<div class="text-center">
								پس اندازهای ماه: {{ reportData.monthSavedMonies.toString().toPriceFormat() }}
								<div />
							</div>
						</v-col>
						<v-col cols="12">
							<div class="text-center">
								مجموع پرادخت نشده ها: {{ reportData.totalUnpaid.toString().toPriceFormat() }}
								<div />
							</div>
						</v-col>
						<v-col cols="12">
							<div class="text-center">
								تراز: {{ reportData.balance.toString().toPriceFormat() }}
								<div />
							</div>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</material-card>
		<confirm-dlg ref="confirm" />
		<div class="py-3" />
	</v-container>
</template>

<script>
	import api from '@/util/app-api'
	import toast from '@/util/toast'

	export default {
		name: 'MonthlyBalance',
		components: {
			ConfirmDlg: () => import('@/components/Confirm'),
		},
		data() {
			return {
				errorMessages: '',
				months: [],
				month: '',
				search: '',
				saveType: 3,
				loading: false,
				reportData: {
					items: [],
					totalSavedMonies: 0,
					balance: 0,
					monthPayments: 0,
					monthSavedMonies: 0,
					totalUnpaid: 0,
				},
				headers: [
					{
						text: 'نام',
						align: 'center',
						sortable: true,
						value: 'fullName',
					}, {
						text: 'کد پرسنلی',
						align: 'start',
						sortable: true,
						value: 'personalCode',
					}, {
						text: 'نوع وام',
						align: 'center',
						sortable: true,
						value: 'loanTitle',
					}, {
						text: 'مبلغ وام',
						align: 'center',
						sortable: true,
						value: 'loanAmount',
					}, {
						text: 'پرداختی ماه',
						align: 'center',
						sortable: true,
						value: 'payments',
					}, {
						text: 'پرداختی از ابتدا',
						align: 'center',
						sortable: true,
						value: 'paymentsTotal',
					}, {
						text: 'مانده',
						align: 'center',
						sortable: true,
						value: 'remain',
					}, {
						text: 'پس انداز ماه',
						align: 'center',
						sortable: true,
						value: 'savedMoney',
					}, {
						text: 'پس انداز از ابتدا',
						align: 'center',
						sortable: true,
						value: 'savedMoneyTotal',
					},
				],
			}
		},
		mounted() {
			this.getMonths()
		},
		methods: {
			getMonths() {
				this.loading = true
				api.get('admin/report/GetMonths', {})
					.then(
						response => {
							this.months = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
			loadData() {
				this.loading = true
				api.get('admin/report/MonthlyBalance/?month=' + this.month + '&saveType=' + this.saveType, {})
					.then(
						response => {
							this.reportData = response
						})
					.catch(err => {
						toast.error(err.message)
					})
					.finally(x => { this.loading = false })
			},
		},
	}
</script>
<style></style>
